<template>
  <div class="card card--white dimension">
    <div class="card card--container">
    <div class="d-header" :style="{color: dimension.graph_color}">{{dimension.name}}</div>
    <div>
      <v-checkbox v-model="dimension.graph" label="Display Graph"/>
    </div>
    <div>
      <label for="">Graph Color:</label>
      <h-btn @click="displayPicker = true">{{dimension.graph_color}}</h-btn>
    </div>
    <h-btn color="primary" flat>Save</h-btn>
    </div>
    <!-- <color-picker v-if="displayPicker" @close="displayPicker=false" @pickedColor="changeColor"/> -->
  </div>
</template>

<script>
export default {
  props: ["dimension"],
  data() {
    return {
      displayPicker: false
    };
  },
  methods: {
    changeColor(color) {
      this.dimension.graph_color = color;
    }
  }
};
</script>
